@if (isVisible$()) {
  <mat-form-field class="conditional__full-width" appearance="outline" [subscriptSizing]="'dynamic'">
    <mat-select [formControl]="surveyConditionalsService.conditionForm$().get('operator') | toFormControl" (selectionChange)="onOperatorChange()">
      @for (
        operator of surveyConditionalsService.questionSelected$() | operatorByType: surveyConditionalsService.conditionForm$().get('optionId')?.value;
        track operator.value
      ) {
        <mat-option [value]="operator.value">{{ operator.text }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
}
